"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Tooltip_Container_1 = __importDefault(require("./Tooltip.Container"));
const useWindowSize_1 = __importDefault(require("../useWindowSize"));
const styled_1 = __importDefault(require("../utils/styled"));
const utils_1 = require("../utils");
const ContentContainer = styled_1.default.div `
  max-width: 25vw;
  max-height: 25vh;
  width: 100%;
  height: 100%;
  overflow: auto;
  ${utils_1.customScrollbar};

  > img {
    max-width: 100%;
  }
`;
const Tooltip = (_a) => {
    var { children, position = "right" } = _a, props = __rest(_a, ["children", "position"]);
    const [rect, setRect] = React.useState(null);
    const [scroll, setScroll] = React.useState([window.scrollX, window.scrollY]);
    const $node = React.useRef(null);
    const windowSize = useWindowSize_1.default();
    React.useEffect(() => {
        const handleScroll = () => setScroll([window.scrollX, window.scrollY]);
        document.addEventListener("scroll", handleScroll);
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);
    React.useEffect(() => {
        const currentNode = $node.current;
        if (currentNode && currentNode.parentElement) {
            const currentNodeRect = currentNode.parentElement.getBoundingClientRect();
            setRect(currentNodeRect);
        }
    }, [windowSize, scroll]);
    const coords = React.useMemo(() => {
        if (!rect) {
            return {
                top: 0,
                left: 0,
            };
        }
        switch (position) {
            case "top":
                return {
                    top: rect.top,
                    left: rect.left + rect.width / 2,
                };
            case "bottom":
                return {
                    top: rect.top + rect.height,
                    left: rect.left + rect.width / 2,
                };
            case "left":
                return {
                    top: rect.top + rect.height / 2,
                    left: rect.left,
                };
            case "right":
                return {
                    top: rect.top + rect.height / 2,
                    left: rect.left + rect.width,
                };
        }
    }, [rect, position]);
    return (React.createElement(Tooltip_Container_1.default, Object.assign({}, props, { visible: Boolean(rect), top: coords.top, left: coords.left, position: position, ref: $node }),
        React.createElement(ContentContainer, null, children)));
};
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map